import $ from 'jquery';
import tippy from 'tippy.js';
import moment from 'moment/moment';
import momentTimezone from 'moment-timezone';
import MatchBarCarousel from 'ui/match-bar/carousel';
import CountdownTimer from 'ui/match-bar/countdown';
import MatchBarView from 'ui/match-bar/match-bar-view';
import MatchBarRepository from 'repositories/matchBarRepository';

const elements = {
    section: '.gamebar-section',
};

const shared = window.__matchSharedAsynchrousLoader__ || false;

const repository = new MatchBarRepository(shared);
const view = new MatchBarView();
const carousel = new MatchBarCarousel();
const countdownTimer = new CountdownTimer();

const initializeTippy = () => {
    tippy('.gamebar-popover-trigger', {
        flip: false,
        interactive: true,
        content: $('#template-gamebar-popover-loader').html(),
        onShown(instance) {
            const reference = instance.reference;
            const date = reference.getAttribute('data-date');
            /*
             * update content
             */
            repository.requestMatch(date).then(response => {
                const html = view.popover(response);
                instance.setContent(html);
            }).catch({
                /*
                 * @TODO close tippy
                 */
            });
        },
        delay: [200, 0],
        theme: 'matchbar',
        arrow: true,
        placement: 'bottom',
        sticky: true,
        arrowType: 'round',
        size: 'large',
        duration: [200, 100],
        animation: 'shift-away',
        hideOnClick: false,
        inertia: false,
    });

    tippy('.gamebar-approval-trigger.not-confirmed', {
        content: 'Termin nie jest jeszcze oficjalnie potwierdzony',
        arrow: true,
        arrowType: 'round',
        placement: 'top',
        sticky: true,
        theme: 'light match-popover',
    });
};

const turnOnCountdownTimer = (current) => {
    if (!current) {
        return;
    }
    let matchDate = momentTimezone.tz(`${current.matchDate} ${current.startHour}`, 'DD.MM.YYYY HH:mm', 'Europe/Warsaw');

    const HOUR_IN_MINUTES = 60;
    const now = moment();

    var duration = moment.duration(matchDate.diff(now));

    /*
     * Checkout conditions to start timer count down / exit
     * Don't go to live mode for past matches and when match starts more than 60 minutes
     */
    if (current.status === 'past') {
        return;
    }

    if (current.status === 'upcoming') {
        countdownTimer.update(matchDate);
        countdownTimer.run();
        countdownTimer.onFinish(function () {
            this.hide();
        });
    }

    if (duration.asMinutes() > HOUR_IN_MINUTES) {
        return;
    }

    if (!current.isLive) {
        return;
    }

    /*
     * Start live mode
     */
    const interval = setInterval(() => {
        repository.requestMatch(matchDate.format('YYYY-MM-DD')).then((match) => {
            /*
             * Update slider current game cell
             */
            const html = view.current(match);
            const $html = $(html.trim());

            carousel.replace($html.html());

            /*
             * Update rwd, sponsors section
             */
            $('.gamebar-section-rwd').html(view.rwd(match));
            $('.gamebar-section-sponsors').html(view.sponsors(match));

            /*
             * Update countdown component
             */
            matchDate = momentTimezone.tz(`${match.matchDate} ${match.startHour}`, 'DD.MM.YYYY HH:mm', 'Europe/Warsaw');

            countdownTimer.update(matchDate);
            countdownTimer.render();

            /*
             * Match is already past - turn on live requesting
             */
            if (match.status === 'past' && !match.isLive) {
                clearInterval(interval);
                return;
            }
        });
    }, 120000);
};

export const init = () => {
    /*
     * Exit component when suspended season state
     */
    const suspended = window.rmpl.get('matches', 'suspended');
    if (suspended) {
        return false;
    }

    /*
     * Document ready section
     */
    $(window).ready(() => {
        /*
         * Verify match bar exists in twig / then load all
         * functions
         */
        const matchBarSectionExists = $(elements.section).length > 0;
        if (!matchBarSectionExists) {
            return false;
        }

        /*
         * Init repository / grab data from match calendar section, or
         * request separately if need
         */
        repository.onInitialize().then((collection) => {
            /*
             * Init all needed components / view / dynamic templates
             */
            view.render(collection);
            countdownTimer.init('.dynamic-match-countdown');

            setTimeout(() => {
                carousel.init();
                initializeTippy();
                turnOnCountdownTimer(collection.live);
            }, 1);

        }).catch(() => {
            /*
             * @TODO - Rejection of promises
             * Handle it by hiding / destroying match bar
             */
        });
        return true;
    });
};

export default { init };



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/match-bar/index.js